import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('user_locale') ? localStorage.getItem('user_locale') : window.config.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: window.config.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {}
})

/**
 * Cada idioma pesa ~80 KB gz: viaja en su propio chunk y solo se baja el que
 * se usa. Un idioma que no existe se ignora y queda el fallback, como antes.
 */
export function loadLocale(locale) {
  if (!locale || i18n.availableLocales.includes(locale)) {
    return Promise.resolve()
  }
  return import(`./locales/${locale}.json`)
    .then(messages => i18n.setLocaleMessage(locale, messages.default || messages))
    .catch(() => {})
}

// Los módulos del store traducen al importarse, así que main.js espera esto
// antes de evaluar el resto de la app.
export const i18nReady = Promise.all([
  loadLocale(i18n.locale),
  loadLocale(i18n.fallbackLocale)
])

export default i18n
